<template>
  <div class="CarMaintenanceList" v-loading="loading.search">
    <!-- 新组件 -->
    <QS-common-table
      :data="tableData"
      :columns="headColumn"
      :pagination="paginationData"
      @change="paginationEvent"
      class="mt16"
    >
      <template slot="col-id" slot-scope="scope">
        <div
          :style="{
            color: judgePermission('vehicle_maintenance_list_detail_new')
              ? '#0059DC'
              : '#0059DC'
          }"
          @click="
            judgePermission('vehicle_maintenance_list_detail_new') &&
              jumpDetail(scope.row)
          "
          style="cursor: pointer"
        >
          {{ scope.row.id }}
        </div>
      </template>
    </QS-common-table>
    <initiateMaintenance @getList="getList(params)" ref="initiateMaintenance" />
    <info-dialog ref="infoDialog" @update="handleInfoDialogUpdate"></info-dialog>
  </div>
</template>
<script>
import { getMaintenanceList, deleteMaintenanceOrder } from '@/api/domain/carsService'
import initiateMaintenance from './initiateMaintenance'
import config from './config'
import InfoDialog from '../list/components/InfoDialog.vue'
import WindowCommunication from '@/utils/windowCommunication'

export default {
  props: {
    loading: {
      type: Object,
      default: () => ({}),
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    // 判断是不是车辆详情
    // eslint-disable-next-line vue/no-unused-properties
    isCarDetail: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    initiateMaintenance,
    InfoDialog,
  },
  data() {
    const { tableColums } = config.call(this)
    return {
      rowData: {},
      // 表格数据
      tableData: [],
      headColumn: tableColums,
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [10, 20, 30, 50],
      },
    }
  },
  methods: {
    handleInfoDialogUpdate() {
      this.rowData = {}
      this.getList(this.params)
    },
    // 维保信息确认
    // eslint-disable-next-line vue/no-unused-properties
    openinfoDialog(row, typeDialog) {
      // typeDialog: 0, // 1: 维保信息确认 2:发起支付 3:维修完成确认
      this.rowData = row
      this.rowData.typeDialog = typeDialog
      this.$refs.infoDialog.open(this.rowData)
    },
    // 发起维保
    // eslint-disable-next-line vue/no-unused-properties
    showMaintenanceDialog(row) {
      this.$refs.initiateMaintenance.row = row
      this.$refs.initiateMaintenance.dialogShow = true
    },

    /* 详情 */
    jumpDetail(row) {
      this.$router.push({
        path: '/vehicle/maintenance/detail',
        query: { id: row.id },
      })
    },
    /* 编辑 */
    // eslint-disable-next-line vue/no-unused-properties
    JumpEdit(data) {
      const { scene } = this.$route.query
      const query = {
        id: data.id,
      }
      if (scene) {
        query.scene = scene
      }
      this.$router.push({
        path: '/vehicle/maintenance/edit',
        query,
      })
    },
    /* 分页 */
    paginationEvent(payload) {
      const {
        pagination: { pageSize, pageNum },
      } = payload
      this.paginationData.pageSize = pageSize
      this.paginationData.pageNum = pageNum
      this.getList(this.params)
    },
    /* 获取列表 */
    async getList(res) {
      // 暂时注释
      // eslint-disable-next-line vue/no-mutating-props
      this.loading.search = true
      const params = {
        ...res,
      }
      try {
        const { code, data } = await getMaintenanceList({
          ...params,
          pageNum: this.paginationData.pageNum,
          pageSize: this.paginationData.pageSize,
        })
        // 暂时注释
        // eslint-disable-next-line vue/no-mutating-props
        this.loading.search = false
        if (code === 1) {
          this.tableData = data.items
          this.paginationData.total = data.totalNum
        }
      } catch {
        // 暂时注释
        // eslint-disable-next-line vue/no-mutating-props
        this.loading.search = false
      }
    },
    // eslint-disable-next-line vue/no-unused-properties
    deleteOrder(row) {
      this.$confirm('将删除该条维保订单记录，是否继续？', '确认', { type: 'warning' })
        .then(() => {
          deleteMaintenanceOrder({
            id: row.id,
          }).then(({ code }) => {
            if (code === 1) {
              this.$message.success('删除成功')
              this.getList(this.params)
              this.sendMessage()
            }
          })
        })
    },
    sendMessage() {
      // 跨页面通信 通知签约提车车辆状态信息刷新
      if (this.$route.query.scene) {
        const communication = new WindowCommunication('person_sign_contract')
        communication.send({
          type: 'unavailable_message',
          data: true,
        })
        // 关闭window
        window.close()
      }
    },
  },
  mounted() {
    this.getList(this.params)
  },
}
</script>

<style lang="scss" scoped></style>
